<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-06 18:27:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-30 15:23:11
-->
<template>
  <div class="box" style="position:relative">
    <!-- -->
    <v-btn
      rounded
      v-btnAuth="['label-internationalization-translation-entry']"
      v-if="$route.name == 'allClientMsg'"
      style="position: absolute;top:-65px;"
      :style="{
        right: hasBtn('add-label-internationalization-info') ? '66px' : '8px',
      }"
      color="primary"
      height="40"
      depressed
      class="text-button"
      @click="goTranslate"
    >
      {{ $t("label_translation") }}
    </v-btn>
    <!-- {{hasBtn('add-label-internationalization-info')}} -->
    <mrc_ess_table
      v-if="$route.name == 'allClientMsg'"
      :headers="headers"
      :search="search"
      pageName="addAllClientMsg"
      :hideAddBtn="!hasBtn('add-label-internationalization-info')"
      :slotKey="[
        'status',
        'language_master_key',
        'language_master_content',
        'language_data_type',
        'language_master_module_uuid',
        'language_master_function_uuid',
      ]"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1, pagesize: $store.state.pageSize })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.language_master_key="{item}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              style="max-width:400px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
              v-bind="attrs"
              v-on="on"
            >
              {{ INT(item.language_master_key) }}
            </div>
          </template>
          <span>{{ INT(item.language_master_key) }}</span>
        </v-tooltip>
      </template>

      <template #item.language_master_module_uuid="{item}">
        {{ INT(item.language_master_module_uuid) }}
      </template>

      <template #item.language_master_function_uuid="{item}">
        {{ INT(item.language_master_function_uuid) }}
      </template>
      <template #item.language_master_content="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              style="max-width:400px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
              v-bind="attrs"
              v-on="on"
            >
              {{ INT(item.language_master_content) }}
            </div>
          </template>
          <span>{{ INT(item.language_master_content) }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.language_data_type="{ item }">
        {{ INT(item.language_data_type) }}
      </template>
      <!-- 状态-->
      <template v-slot:item.status="{ item }">
        <mrc_ess_viewbtn
          :label="item.status"
          :is_used="item.status_save_value"
        ></mrc_ess_viewbtn>
      </template>

      <!-- 按钮 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-label-internationalization-info',
                'edit-label-internationalization-info',
                'delete-label-internationalization-info',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>

    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  gethintList,
  gethintDetail,
  deletehint,
  addehint,
} from "@/service/api/internationalization.js"

export default {
  components: {},
  props: {},
  data() {
    return {
      systemSeniorQueryString: [],
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
      search: "",
    }
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  created() {},
  async mounted() {
    // console.log(this.$route.meta.title);
    await this.getlist()
  },
  beforeDestroy() {},
  methods: {
    searchChange(v) {
      this.search = v
    },
    goTranslate() {
      this.$router.push({
        name: "detaillabelInttranslation",
      })
    },
    rowgodetail(item) {
      // console.log(item);
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_uuid2", "") //类型
      this.$store.commit("set_uuid", item.uuid) //
      this.$store.commit("set_subPage_name", item.language_master_key) //
      this.$router.push({
        name: "detailAllClientMsg",
        params: { title: item.language_master_key },
      })
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.rowgodetail(obj)
          break
        case "edit":
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid2", "") //类型
          this.$store.commit("set_uuid", obj.uuid) //
          this.$store.commit("set_subPage_name", obj.language_master_key) //
          this.$router.push({
            name: "detailAllClientMsg",
            params: { title: obj.language_master_key },
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          })
            .then((res) => {
              deletehint({
                uuid: obj.uuid,
              }).then((res) => {
                if (res.code == 200) {
                  this.$Message({
                    text: this.$t("message_The_deletion_was_successful"),
                  })
                  this.getlist()
                }
              })
            })
            .catch((err) => {})
          break
      }
    },
    goadd() {
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$store.commit("set_uuid", "") //
      this.$store.commit("set_uuid2", "") //类型
      this.$store.commit("set_subPage_name", "") //
      this.$router.push({
        name: "addAllClientMsg",
      })
    },
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj

        this.options = { ...this.options, ...obj }
      }
      const client_type = this.$store.state.client_type
      // const version = this.$store.state.version
      const uuids = this.$store.state.version_uuid
      const res = await gethintList({
        //换个类型
        client_type,
        uuids,
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        // this.$set(this.options, 'totalcount', res.totalcount)
        // this.$set(this.options, 'totalpage', res.totalpage)
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
          ? res.field_alias_name
          : null
        this.table_alias_name = res.table_alias_name
          ? res.table_alias_name
          : null
      }
      this.loading = false
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Key",
          align: "start",
          sortable: false,
          width: 20,
          value: "language_master_key",
        },
        {
          text: this.$t("label_The_name_of_the_module"),
          align: "start",
          sortable: false,
          value: "language_master_module_uuid",
        },
        {
          text: this.$t("label_The_name_of_the_function"),
          align: "start",
          sortable: false,
          value: "language_master_function_uuid",
        },
        {
          text: this.$t("label_content"),
          align: "start",
          sortable: false,
          value: "language_master_content",
        },
        {
          text: this.$t("label_version"),
          align: "center",
          sortable: false,
          value: "version_uuid",
        },
        {
          text: this.$t("label_type"),
          align: "center",
          sortable: false,
          value: "language_data_type",
        },
        {
          text: this.$t("label_state"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-label-internationalization-info"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-label-internationalization-info"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-label-internationalization-info"),
          type: "del",
        },
      ]
    },
  },
  watch: {
    $route(v) {
      if (v.name == "allClientMsg") {
        this.getlist()
      }
    },
  },
}
</script>

<style scoped>
/* .box /deep/ .btnGroup {
  position: relative;
}
.box /deep/ .addBtn {
  color: #fff;
  position: absolute;
  top: -55px;
  right: 10px;
} */
</style>
